export default __webpack_public_path__ + "static/BairdHolm-174c40032260b2f7978312f09abfafb7.webp";